import React, { useContext } from 'react';

import { LocationContext } from 'app/containers/LocationProvider';
import { OverlayContextDispatch } from 'app/containers/contexts/overlay.context';
import { analyticService } from 'global/services';
import { citiesLocales as cities } from 'app/const/location';

/**
 * @description Диалог отображает уведомление о том что на выбранную дату нет доступных интервалов доставки
 * @see fetchTimeIntervalWithDateData
 */
export const useCitySelectMenuDialog = () => {
    const {
        closeLastOverlays, pushSelectMobileOverlay,
    } = useContext(OverlayContextDispatch);

    const {
        locationKey, mutateAddreessHandler, isLocationDataLoading,
    } = useContext(LocationContext);
    const addressString = {
        MSK: 'г Москва',
        SPB: 'г Санкт-Петербург',
        NIZ: 'г Нижний Новгород',
        KZN: 'г Казань',
        TUL: 'г Тула',
        YAR: 'г Ярославль',
        VLA: 'г Владимир',

        RYA: 'г Рязань',
        KLU: 'г Калуга',
        TVE: 'г Тверь',
        VOR: 'г Воронеж',
    };

    const items = cities.map((city) => {
        const selected = city.id === locationKey;

        return {
            id: `mobile-city-select-${city.id}`,
            buttonProps: {
                onClick: () => {
                    mutateAddreessHandler(
                        { address: addressString[city.id] },
                        undefined,
                    );
                    analyticService.push({
                        eventName: 'Filter_Change_City',
                        filter_value: city.id,
                        eventAction: 'Change',
                        eventLabel: 'City',
                    });
                    closeLastOverlays();
                },
                name: `btn-${city.id.toLowerCase()}`,
                disabled: isLocationDataLoading || selected,
            },
            TextCmp: <>{city.value}</>,
            selected,
        };
    });

    const selectData = {
        headerText: 'Выбор города',
        sections: [{ items, id: 'city-select' }],
    };


    const pushCitySelectDialog = () => {
        pushSelectMobileOverlay(
            'city_select',
            selectData,
            { onClick: () => closeLastOverlays() },
        );
    };
    return { pushCitySelectDialog };
};
